const lang = localStorage.getItem('i18nextLng');

const getTerm = () => {
  if (lang === 'tr') {
    return 'BİLİNMEYEN';
  } else if (lang === 'uz') {
    return "NOMA'LUM";
  } else if (lang === 'en') {
    return 'UNKNOWN';
  } else {
    return 'НЕИЗВЕСТНА';
  }
};

export default [
  {
    id: '1',
    label: '008  ',
    country: 'АЛБАНИЯ',
  },
  {
    id: '2',
    label: '010  ',
    country: 'АНТАРКТИДА',
  },
  {
    id: '3',
    label: '000  ',
    country: getTerm(),
  },
  {
    id: '4',
    label: '012  ',
    country: 'АЛЖИР',
  },
  {
    id: '5',
    label: '016  ',
    country: 'ВОСТОЧНОЕ САМОА',
  },
  {
    id: '6',
    label: '020  ',
    country: 'АНДОРРА',
  },
  {
    id: '7',
    label: '024  ',
    country: 'АНГОЛА',
  },
  {
    id: '8',
    label: '028  ',
    country: 'АНТИГУА И БАРБУДА',
  },
  {
    id: '9',
    label: '031  ',
    country: 'АЗЕРБАЙДЖАН',
  },
  {
    id: '10',
    label: '032  ',
    country: 'АРГЕНТИНА',
  },
  {
    id: '11',
    label: '036  ',
    country: 'АВСТРАЛИЯ',
  },
  {
    id: '12',
    label: '040  ',
    country: 'АВСТРИЯ',
  },
  {
    id: '13',
    label: '044  ',
    country: 'БАГАМЫ',
  },
  {
    id: '14',
    label: '048  ',
    country: 'БАХРЕЙН',
  },
  {
    id: '15',
    label: '050  ',
    country: 'БАНГЛАДЕШ',
  },
  {
    id: '16',
    label: '051  ',
    country: 'АРМЕНИЯ',
  },
  {
    id: '17',
    label: '052  ',
    country: 'БАРБАДОС',
  },
  {
    id: '18',
    label: '056  ',
    country: 'БЕЛЬГИЯ',
  },
  {
    id: '19',
    label: '060  ',
    country: 'БЕРМУДЫ',
  },
  {
    id: '20',
    label: '064  ',
    country: 'БУТАН',
  },
  {
    id: '21',
    label: '068  ',
    country: 'БОЛИВИЯ',
  },
  {
    id: '22',
    label: '070  ',
    country: 'БОСНИЯ И ГЕРЦЕГОВИНА',
  },
  {
    id: '23',
    label: '072  ',
    country: 'БОТСВАНА',
  },
  {
    id: '24',
    label: '074  ',
    country: 'БУВЕ',
  },
  {
    id: '25',
    label: '076  ',
    country: 'БРАЗИЛИЯ',
  },
  {
    id: '26',
    label: '084  ',
    country: 'БЕЛИЗ',
  },
  {
    id: '27',
    label: '086  ',
    country: 'БРИТАН. ТЕРРИТ',
  },
  {
    id: '28',
    label: '090  ',
    country: 'СОЛОМОНОВЫ О-ВА',
  },
  {
    id: '29',
    label: '092  ',
    country: 'ВИРГИН. О-ВА, БРИТАНСКИЕ',
  },
  {
    id: '30',
    label: '096  ',
    country: 'БРУНЕЙ',
  },
  {
    id: '31',
    label: '100  ',
    country: 'БОЛГАРИЯ',
  },
  {
    id: '32',
    label: '104  ',
    country: 'МЬЯНМА',
  },
  {
    id: '33',
    label: '108  ',
    country: 'БУРУНДИ',
  },
  {
    id: '34',
    label: '112  ',
    country: 'БЕЛАРУСЬ',
  },
  {
    id: '35',
    label: '116  ',
    country: 'КАМБОДЖА',
  },
  {
    id: '36',
    label: '120  ',
    country: 'КАМЕРУН',
  },
  {
    id: '37',
    label: '124  ',
    country: 'КАНАДА',
  },
  {
    id: '38',
    label: '132  ',
    country: 'КАБО - ВЕРДЕ',
  },
  {
    id: '39',
    label: '136  ',
    country: 'КАЙМАН',
  },
  {
    id: '40',
    label: '140  ',
    country: 'ЦЕНТР. - АФР РЕСПУБЛИКА.',
  },
  {
    id: '41',
    label: '144  ',
    country: 'ШРИ-ЛАНКА',
  },
  {
    id: '42',
    label: '148  ',
    country: 'ЧАД',
  },
  {
    id: '43',
    label: '152  ',
    country: 'ЧИЛИ',
  },
  {
    id: '44',
    label: '156  ',
    country: 'КИТАЙ',
  },
  {
    id: '45',
    label: '158  ',
    country: 'ТАЙВАНЬ',
  },
  {
    id: '46',
    label: '162  ',
    country: 'О-В РОЖДЕСТВА',
  },
  {
    id: '47',
    label: '166  ',
    country: 'КОКОСОВЫЕ О-ВА',
  },
  {
    id: '48',
    label: '170  ',
    country: 'КОЛУМБИЯ',
  },
  {
    id: '49',
    label: '174  ',
    country: 'КОМОРЫ',
  },
  {
    id: '50',
    label: '175  ',
    country: 'МАЙОТТА',
  },
  {
    id: '51',
    label: '178  ',
    country: 'КОНГО',
  },
  {
    id: '52',
    label: '180  ',
    country: 'КОНГО',
  },
  {
    id: '53',
    label: '184  ',
    country: 'О-ВА КУКА',
  },
  {
    id: '54',
    label: '188  ',
    country: 'КОСТА-РИКА',
  },
  {
    id: '55',
    label: '191  ',
    country: 'ХОРВАТИЯ',
  },
  {
    id: '56',
    label: '192  ',
    country: 'КУБА',
  },
  {
    id: '57',
    label: '196  ',
    country: 'КИПР',
  },
  {
    id: '58',
    label: '203  ',
    country: 'ЧЕХИЯ',
  },
  {
    id: '59',
    label: '204  ',
    country: 'БЕНИН',
  },
  {
    id: '60',
    label: '004  ',
    country: 'АФГАНИСТАН',
  },
  {
    id: '61',
    label: '208  ',
    country: 'ДАНИЯ',
  },
  {
    id: '62',
    label: '212  ',
    country: 'ДОМИНИКА',
  },
  {
    id: '63',
    label: '214  ',
    country: 'ДОМИНИКАНСКАЯ РЕСПУБЛИКА',
  },
  {
    id: '64',
    label: '218  ',
    country: 'ЭКВАДОР',
  },
  {
    id: '65',
    label: '222  ',
    country: 'ЭЛЬ-САЛЬВАДОР',
  },
  {
    id: '66',
    label: '226  ',
    country: 'ЭКВАТОРИАЛЬНАЯ ГВИНЕЯ',
  },
  {
    id: '67',
    label: '231  ',
    country: 'ЭФИОПИЯ',
  },
  {
    id: '68',
    label: '232  ',
    country: 'ЭРИТРЕЯ',
  },
  {
    id: '69',
    label: '233  ',
    country: 'ЭСТОНИЯ',
  },
  {
    id: '70',
    label: '234  ',
    country: 'ФАРЕРСКИЕ О-ВА',
  },
  {
    id: '71',
    label: '238  ',
    country: 'ФОЛКЛЕНДСКИЕ О-ВА',
  },
  {
    id: '72',
    label: '239  ',
    country: 'ЮЖНАЯ ДЖОРДЖИЯ И ЮЖНЫЕ СА',
  },
  {
    id: '73',
    label: '242  ',
    country: 'ФИДЖИ',
  },
  {
    id: '74',
    label: '246  ',
    country: 'ФИНЛЯНДИЯ',
  },
  {
    id: '75',
    label: '248  ',
    country: 'ЭЛАНДСКИЕ ОСТРОВА',
  },
  {
    id: '76',
    label: '250  ',
    country: 'ФРАНЦИЯ',
  },
  {
    id: '77',
    label: '254  ',
    country: 'ГВИАНА',
  },
  {
    id: '78',
    label: '258  ',
    country: 'ФРАНЦУЗСКАЯ ПОЛИНЕЗИЯ',
  },
  {
    id: '79',
    label: '260  ',
    country: 'ФР. ЮЖНЫЕ ТЕРРИТОРИИ',
  },
  {
    id: '80',
    label: '262  ',
    country: 'ДЖИБУТИ',
  },
  {
    id: '81',
    label: '266  ',
    country: 'ГАБОН',
  },
  {
    id: '82',
    label: '268  ',
    country: 'ГРУЗИЯ',
  },
  {
    id: '83',
    label: '270  ',
    country: 'ГАМБИЯ',
  },
  {
    id: '84',
    label: '275  ',
    country: 'ПАЛЕСТИНСКАЯ ТЕРРИТОРИЯ',
  },
  {
    id: '85',
    label: '276  ',
    country: 'ГЕРМАНИЯ',
  },
  {
    id: '86',
    label: '288  ',
    country: 'ГАНА',
  },
  {
    id: '87',
    label: '292  ',
    country: 'ГИБРАЛТАР',
  },
  {
    id: '88',
    label: '296  ',
    country: 'КИРИБАТИ',
  },
  {
    id: '89',
    label: '300  ',
    country: 'ГРЕЦИЯ',
  },
  {
    id: '90',
    label: '304  ',
    country: 'ГРЕНЛАНДИЯ',
  },
  {
    id: '91',
    label: '308  ',
    country: 'ГРЕНАДА',
  },
  {
    id: '92',
    label: '312  ',
    country: 'ГВАДЕЛУПА',
  },
  {
    id: '93',
    label: '316  ',
    country: 'ГУАМ',
  },
  {
    id: '94',
    label: '320  ',
    country: 'ГВАТЕМАЛА',
  },
  {
    id: '95',
    label: '324  ',
    country: 'ГВИНЕЯ',
  },
  {
    id: '96',
    label: '328  ',
    country: 'ГАЙАНА',
  },
  {
    id: '97',
    label: '332  ',
    country: 'ГАИТИ',
  },
  {
    id: '98',
    label: '334  ',
    country: 'ХЕРД И МАКДОНАЛЬД',
  },
  {
    id: '99',
    label: '336  ',
    country: 'ВАТИКАН',
  },
  {
    id: '100',
    label: '340  ',
    country: 'ГОНДУРАС',
  },
  {
    id: '101',
    label: '344  ',
    country: 'ГОНКОНГ',
  },
  {
    id: '102',
    label: '348  ',
    country: 'ВЕНГРИЯ',
  },
  {
    id: '103',
    label: '352  ',
    country: 'ИСЛАНДИЯ',
  },
  {
    id: '104',
    label: '356  ',
    country: 'ИНДИЯ',
  },
  {
    id: '105',
    label: '360  ',
    country: 'ИНДОНЕЗИЯ',
  },
  {
    id: '106',
    label: '364  ',
    country: 'ИРАН',
  },
  {
    id: '107',
    label: '368  ',
    country: 'ИРАК',
  },
  {
    id: '108',
    label: '372  ',
    country: 'ИРЛАНДИЯ',
  },
  {
    id: '109',
    label: '376  ',
    country: 'ИЗРАИЛЬ',
  },
  {
    id: '110',
    label: '380  ',
    country: 'ИТАЛИЯ',
  },
  {
    id: '111',
    label: '384  ',
    country: 'КОТ  Д`ИВУАР',
  },
  {
    id: '112',
    label: '388  ',
    country: 'ЯМАЙКА',
  },
  {
    id: '113',
    label: '392  ',
    country: 'ЯПОНИЯ',
  },
  {
    id: '114',
    label: '398  ',
    country: 'КАЗАХСТАН',
  },
  {
    id: '115',
    label: '400  ',
    country: 'ИОРДАНИЯ',
  },
  {
    id: '116',
    label: '404  ',
    country: 'КЕНИЯ',
  },
  {
    id: '117',
    label: '408  ',
    country: 'КОРЕЯ (КНДР)',
  },
  {
    id: '118',
    label: '410  ',
    country: 'КОРЕЯ',
  },
  {
    id: '119',
    label: '414  ',
    country: 'КУВЕЙТ',
  },
  {
    id: '120',
    label: '417  ',
    country: 'КЫРГЫЗСТАН',
  },
  {
    id: '121',
    label: '418  ',
    country: 'ЛАОС',
  },
  {
    id: '122',
    label: '422  ',
    country: 'ЛИВАН',
  },
  {
    id: '123',
    label: '426  ',
    country: 'ЛЕСОТО',
  },
  {
    id: '124',
    label: '428  ',
    country: 'ЛАТВИЯ',
  },
  {
    id: '125',
    label: '430  ',
    country: 'ЛИБЕРИЯ',
  },
  {
    id: '126',
    label: '434  ',
    country: 'ЛИВИЯ',
  },
  {
    id: '127',
    label: '438  ',
    country: 'ЛИХТЕНШТЕЙН',
  },
  {
    id: '128',
    label: '440  ',
    country: 'ЛИТВА',
  },
  {
    id: '129',
    label: '442  ',
    country: 'ЛЮКСЕМБУРГ',
  },
  {
    id: '130',
    label: '446  ',
    country: 'МАКАО',
  },
  {
    id: '131',
    label: '450  ',
    country: 'МАДАГАСКАР',
  },
  {
    id: '132',
    label: '454  ',
    country: 'МАЛАВИ',
  },
  {
    id: '133',
    label: '458  ',
    country: 'МАЛАЙЗИЯ',
  },
  {
    id: '134',
    label: '462  ',
    country: 'МАЛЬДИВЫ',
  },
  {
    id: '135',
    label: '466  ',
    country: 'МАЛИ',
  },
  {
    id: '136',
    label: '470  ',
    country: 'МАЛЬТА',
  },
  {
    id: '137',
    label: '474  ',
    country: 'МАРТИНИКА',
  },
  {
    id: '138',
    label: '478  ',
    country: 'МАВРИТАНИЯ',
  },
  {
    id: '139',
    label: '480  ',
    country: 'МАВРИКИЙ',
  },
  {
    id: '140',
    label: '484  ',
    country: 'МЕКСИКА',
  },
  {
    id: '141',
    label: '492  ',
    country: 'МОНАКО',
  },
  {
    id: '142',
    label: '496  ',
    country: 'МОНГОЛИЯ',
  },
  {
    id: '143',
    label: '498  ',
    country: 'МОЛДОВА',
  },
  {
    id: '144',
    label: '499  ',
    country: 'ЧЕРНОГОРИЯ',
  },
  {
    id: '145',
    label: '500  ',
    country: 'МОНТСЕРРАТ',
  },
  {
    id: '146',
    label: '504  ',
    country: 'МАРОККО',
  },
  {
    id: '147',
    label: '508  ',
    country: 'МОЗАМБИК',
  },
  {
    id: '148',
    label: '512  ',
    country: 'ОМАН',
  },
  {
    id: '149',
    label: '516  ',
    country: 'НАМИБИЯ',
  },
  {
    id: '150',
    label: '520  ',
    country: 'НАУРУ',
  },
  {
    id: '151',
    label: '524  ',
    country: 'НЕПАЛ',
  },
  {
    id: '152',
    label: '528  ',
    country: 'НИДЕРЛАНДЫ',
  },
  {
    id: '153',
    label: '530  ',
    country: 'НИДЕРЛАНДСКИЕ АНТИЛЫ',
  },
  {
    id: '154',
    label: '533  ',
    country: 'АРУБА',
  },
  {
    id: '155',
    label: '540  ',
    country: 'НОВАЯ КАЛЕДОНИЯ',
  },
  {
    id: '156',
    label: '548  ',
    country: 'ВАНУАТУ',
  },
  {
    id: '157',
    label: '554  ',
    country: 'НОВАЯ ЗЕЛАНДИЯ',
  },
  {
    id: '158',
    label: '558  ',
    country: 'НИКАРАГУА',
  },
  {
    id: '159',
    label: '562  ',
    country: 'НИГЕР',
  },
  {
    id: '160',
    label: '566  ',
    country: 'НИГЕРИЯ',
  },
  {
    id: '161',
    label: '570  ',
    country: 'НИУЭ',
  },
  {
    id: '162',
    label: '574  ',
    country: 'НОРФОЛК',
  },
  {
    id: '163',
    label: '578  ',
    country: 'НОРВЕГИЯ',
  },
  {
    id: '164',
    label: '580  ',
    country: 'МАРИАНСКИЕ ОСТРОВА',
  },
  {
    id: '165',
    label: '581  ',
    country: 'МАЛЫЕ ТИХООК. ОСТРОВА (СШ',
  },
  {
    id: '166',
    label: '583  ',
    country: 'МИКРОНЕЗИЯ',
  },
  {
    id: '167',
    label: '584  ',
    country: 'МАРШАЛЛОВЫ',
  },
  {
    id: '168',
    label: '585  ',
    country: 'ПАЛАУ',
  },
  {
    id: '169',
    label: '586  ',
    country: 'ПАКИСТАН',
  },
  {
    id: '170',
    label: '591  ',
    country: 'ПАНАМА',
  },
  {
    id: '171',
    label: '598  ',
    country: 'ПАПУА - НОВАЯ ГВИНЕЯ',
  },
  {
    id: '172',
    label: '600  ',
    country: 'ПАРАГВАЙ',
  },
  {
    id: '173',
    label: '604  ',
    country: 'ПЕРУ',
  },
  {
    id: '174',
    label: '608  ',
    country: 'ФИЛИППИНЫ',
  },
  {
    id: '175',
    label: '612  ',
    country: 'ПИТКЭРН',
  },
  {
    id: '176',
    label: '616  ',
    country: 'ПОЛЬША',
  },
  {
    id: '177',
    label: '620  ',
    country: 'ПОРТУГАЛИЯ',
  },
  {
    id: '178',
    label: '624  ',
    country: 'ГВИНЕЯ - БИСАУ',
  },
  {
    id: '179',
    label: '626  ',
    country: 'ТИМОР-ЛЕСТЕ',
  },
  {
    id: '180',
    label: '630  ',
    country: 'ПУЭРТО-РИКО',
  },
  {
    id: '181',
    label: '634  ',
    country: 'КАТАР',
  },
  {
    id: '182',
    label: '638  ',
    country: 'РЕЮНЬОН',
  },
  {
    id: '183',
    label: '642  ',
    country: 'РУМЫНИЯ',
  },
  {
    id: '184',
    label: '643  ',
    country: 'РОССИЯ',
  },
  {
    id: '185',
    label: '646  ',
    country: 'РУАНДА',
  },
  {
    id: '186',
    label: '654  ',
    country: 'СВЯТАЯ ЕЛЕНА',
  },
  {
    id: '187',
    label: '659  ',
    country: 'СЕНТ-КИТС И НЕВИС',
  },
  {
    id: '188',
    label: '660  ',
    country: 'АНГИЛЬЯ',
  },
  {
    id: '189',
    label: '662  ',
    country: 'СЕНТ-ЛЮСИЯ',
  },
  {
    id: '190',
    label: '666  ',
    country: 'СЕН - ПЬЕР И МИКЕЛОН',
  },
  {
    id: '191',
    label: '670  ',
    country: 'СЕНТ - ВИНСЕНТ И ГРЕНАДИН',
  },
  {
    id: '192',
    label: '674  ',
    country: 'САН-МАРИНО',
  },
  {
    id: '193',
    label: '678  ',
    country: 'САН - ТОМЕ И ПРИНСИПИ',
  },
  {
    id: '194',
    label: '682  ',
    country: 'САУДОВСКАЯ АРАВИЯ',
  },
  {
    id: '195',
    label: '686  ',
    country: 'СЕНЕГАЛ',
  },
  {
    id: '196',
    label: '688  ',
    country: 'СЕРБИЯ',
  },
  {
    id: '197',
    label: '690  ',
    country: 'СЕЙШЕЛЫ',
  },
  {
    id: '198',
    label: '694  ',
    country: 'СЬЕРРА - ЛЕОНЕ',
  },
  {
    id: '199',
    label: '702  ',
    country: 'СИНГАПУР',
  },
  {
    id: '200',
    label: '703  ',
    country: 'СЛОВАКИЯ',
  },
  {
    id: '201',
    label: '704  ',
    country: 'ВЬЕТНАМ',
  },
  {
    id: '202',
    label: '705  ',
    country: 'СЛОВЕНИЯ',
  },
  {
    id: '203',
    label: '706  ',
    country: 'СОМАЛИ',
  },
  {
    id: '204',
    label: '710  ',
    country: 'ЮЖНАЯ АФРИКА',
  },
  {
    id: '205',
    label: '716  ',
    country: 'ЗИМБАБВЕ',
  },
  {
    id: '206',
    label: '724  ',
    country: 'ИСПАНИЯ',
  },
  {
    id: '207',
    label: '732  ',
    country: 'ЗАПАДНАЯ САХАРА',
  },
  {
    id: '208',
    label: '736  ',
    country: 'СУДАН',
  },
  {
    id: '209',
    label: '740  ',
    country: 'СУРИНАМ',
  },
  {
    id: '210',
    label: '744  ',
    country: 'ШПИЦБЕРГЕН И ЯН - МАЙЕН',
  },
  {
    id: '211',
    label: '748  ',
    country: 'СВАЗИЛЕНД',
  },
  {
    id: '212',
    label: '752  ',
    country: 'ШВЕЦИЯ',
  },
  {
    id: '213',
    label: '756  ',
    country: 'ШВЕЙЦАРИЯ',
  },
  {
    id: '214',
    label: '760  ',
    country: 'СИРИЯ',
  },
  {
    id: '215',
    label: '762  ',
    country: 'ТАДЖИКИСТАН',
  },
  {
    id: '216',
    label: '764  ',
    country: 'ТАИЛАНД',
  },
  {
    id: '217',
    label: '768  ',
    country: 'ТОГО',
  },
  {
    id: '218',
    label: '772  ',
    country: 'ТОКЕЛАУ',
  },
  {
    id: '219',
    label: '776  ',
    country: 'ТОНГА',
  },
  {
    id: '220',
    label: '780  ',
    country: 'ТРИНИДАД И ТОБАГО',
  },
  {
    id: '221',
    label: '784  ',
    country: 'ОБЪЕД. АРАБСКИЕ ЭМИРАТЫ',
  },
  {
    id: '222',
    label: '788  ',
    country: 'ТУНИС',
  },
  {
    id: '223',
    label: '792  ',
    country: 'ТУРЦИЯ',
  },
  {
    id: '224',
    label: '795  ',
    country: 'ТУРКМЕНИЯ',
  },
  {
    id: '225',
    label: '796  ',
    country: 'ТЕРКС И КАЙКОС',
  },
  {
    id: '226',
    label: '798  ',
    country: 'ТУВАЛУ',
  },
  {
    id: '227',
    label: '800  ',
    country: 'УГАНДА',
  },
  {
    id: '228',
    label: '804  ',
    country: 'УКРАИНА',
  },
  {
    id: '229',
    label: '807  ',
    country: 'МАКЕДОНИЯ',
  },
  {
    id: '230',
    label: '818  ',
    country: 'ЕГИПЕТ',
  },
  {
    id: '231',
    label: '826  ',
    country: 'СОЕДИНЕННОЕ КОРОЛЕВСТВО',
  },
  {
    id: '232',
    label: '831  ',
    country: 'ГЕРНСИ',
  },
  {
    id: '233',
    label: '832  ',
    country: 'ДЖЕРСИ',
  },
  {
    id: '234',
    label: '833  ',
    country: 'О-В МЭН',
  },
  {
    id: '235',
    label: '834  ',
    country: 'ТАНЗАНИЯ',
  },
  {
    id: '236',
    label: '840  ',
    country: 'США',
  },
  {
    id: '237',
    label: '850  ',
    country: 'ВИРГИН. О-ВА',
  },
  {
    id: '238',
    label: '854  ',
    country: 'БУРКИНА - ФАСО',
  },
  {
    id: '239',
    label: '858  ',
    country: 'УРУГВАЙ',
  },
  {
    id: '240',
    label: '860  ',
    country: 'УЗБЕКИСТАН',
  },
  {
    id: '241',
    label: '862  ',
    country: 'ВЕНЕСУЭЛА',
  },
  {
    id: '242',
    label: '876  ',
    country: 'УОЛЛИС И ФУТУНА',
  },
  {
    id: '243',
    label: '882  ',
    country: 'САМОА',
  },
  {
    id: '244',
    label: '887  ',
    country: 'ЙЕМЕН',
  },
  {
    id: '245',
    label: '894  ',
    country: 'ЗАМБИЯ',
  },
  {
    id: '246',
    label: '999  ',
    country: 'РАЗНЫЕ',
  },
];
